// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.contracts-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.contracts-panel {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  width: min(1000px, 94vw);
  height: min(680px, 90vh);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.contracts-panel * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .contracts-panel {
    animation: none;
  }
}
.contracts-panel h1, .contracts-panel h2, .contracts-panel h3, .contracts-panel p, .contracts-panel ul, .contracts-panel dl, .contracts-panel dd {
  margin: 0;
  padding: 0;
}
.contracts-panel ul {
  list-style: none;
}

.contracts-header {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 24px 12px;
}
.contracts-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.contracts-header__sub {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin-top: 4px;
}
.contracts-header__purse {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  padding: 6px 14px;
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
}
.contracts-header__purse span {
  font-size: 12px;
  font-weight: 600;
  color: #8d8a82;
}
.contracts-header__purse strong {
  font-size: 17px;
  font-weight: 600;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}

.contracts-tabs {
  flex: 0 0 auto;
  display: flex;
  gap: 2px;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.contracts-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.contracts-tab:hover {
  color: #ebe8e1;
}
.contracts-tab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.contracts-tab--active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.contracts-tab__count {
  display: inline-block;
  min-width: 20px;
  padding: 1px 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
}

.contracts-notice {
  flex: 0 0 auto;
  margin: 12px 24px 0;
  padding: 9px 12px;
  font-size: 14px;
  line-height: 1.4;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-left-width: 3px;
  border-radius: 6px;
}
.contracts-notice--ok {
  border-left-color: #8fbf8a;
}
.contracts-notice--error {
  border-left-color: #d9786d;
}

.contracts-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.contracts-split {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);
}

.contracts-pane {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.contracts-filter {
  flex: 0 0 auto;
  padding: 14px 16px 6px;
}

.contracts-chips {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.contracts-chips::-webkit-scrollbar {
  height: 4px;
}
.contracts-chips::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}
.contracts-chips--wrap {
  flex-wrap: wrap;
  overflow: visible;
  padding-bottom: 0;
}

.contracts-chip {
  flex: 0 0 auto;
  padding: 5px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: #aeaba2;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.contracts-chip:hover {
  color: #ebe8e1;
  border-color: var(--gold-dark);
}
.contracts-chip:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.contracts-chip--active {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.contracts-chip--active:hover {
  color: #14100a;
  border-color: var(--gold-main);
}
.contracts-chip--static {
  cursor: default;
}
.contracts-chip--static:hover {
  color: #aeaba2;
  border-color: rgba(255, 255, 255, 0.2);
}

.contracts-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.contracts-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 4px 10px 12px 12px;
  scrollbar-gutter: stable;
}
.contracts-list::-webkit-scrollbar {
  width: 6px;
}
.contracts-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.contracts-row {
  position: relative;
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 10px 10px 12px;
  margin-bottom: 2px;
  font-family: inherit;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.1s ease;
}
.contracts-row::before {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  bottom: 20%;
  width: 3px;
  border-radius: 2px;
  background: var(--gold-main);
  opacity: 0;
  transition: opacity 0.1s ease;
}
.contracts-row:hover {
  background: rgba(255, 255, 255, 0.06);
}
.contracts-row:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.contracts-row--selected {
  background: rgba(255, 255, 255, 0.09);
}
.contracts-row--selected::before {
  opacity: 1;
}

.contracts-row__reward {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
}
.contracts-row__reward strong {
  font-size: 21px;
  font-weight: 600;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}
.contracts-row__reward span {
  margin-top: 2px;
  font-size: 12px;
  color: #8d8a82;
}

.contracts-row__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contracts-row__title {
  font-size: 15px;
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contracts-row__sub {
  font-size: 13px;
  color: #8d8a82;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contracts-row__side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.contracts-row__time {
  font-size: 12px;
  color: #8d8a82;
  white-space: nowrap;
}

.contracts-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #aeaba2;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
}
.contracts-tag--open {
  color: var(--gold-light);
  border-color: var(--gold-dark);
}
.contracts-tag--accepted {
  color: #ebe8e1;
}
.contracts-tag--delivered {
  color: #8fbf8a;
  border-color: rgba(143, 191, 138, 0.5);
}
.contracts-tag--settled {
  color: #8fbf8a;
  border-color: rgba(143, 191, 138, 0.5);
}
.contracts-tag--cancelled, .contracts-tag--expired {
  color: #8d8a82;
}
.contracts-tag--disputed {
  color: #d9786d;
  border-color: rgba(217, 120, 109, 0.5);
}

.contracts-detail {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: rgba(255, 255, 255, 0.02);
}
.contracts-detail--empty {
  align-items: center;
  justify-content: center;
  color: #8d8a82;
  font-size: 14px;
  text-align: center;
  padding: 24px;
}
.contracts-detail__top {
  flex: 0 0 auto;
  padding: 22px 26px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.contracts-detail__tags {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}
.contracts-detail__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  overflow-wrap: anywhere;
}
.contracts-detail__reward {
  margin-top: 10px;
  font-size: 15px;
  color: #aeaba2;
}
.contracts-detail__reward strong {
  font-size: 30px;
  font-weight: 600;
  color: var(--gold-light);
  font-variant-numeric: tabular-nums;
}
.contracts-detail__body {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 18px 26px;
}
.contracts-detail__body::-webkit-scrollbar {
  width: 6px;
}
.contracts-detail__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.contracts-detail__text {
  font-size: 15px;
  line-height: 1.55;
  color: #ebe8e1;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.contracts-detail__text--none {
  color: #8d8a82;
}
.contracts-detail__heading {
  margin: 22px 0 8px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
}
.contracts-detail__actions {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 26px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.contracts-facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 18px;
}
.contracts-facts > div {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.contracts-facts dt {
  font-size: 12px;
  font-weight: 600;
  color: #8d8a82;
}
.contracts-facts dd {
  margin-top: 3px;
  font-size: 14px;
  font-weight: 600;
  color: #ebe8e1;
  overflow-wrap: anywhere;
}

.contracts-log {
  display: flex;
  flex-direction: column;
}
.contracts-log li {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 12px;
  padding: 7px 0;
  font-size: 14px;
  color: #aeaba2;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.contracts-log__date {
  font-size: 13px;
  color: #8d8a82;
  white-space: nowrap;
}

.contracts-form {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding: 20px 24px;
}
.contracts-form::-webkit-scrollbar {
  width: 6px;
}
.contracts-form::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.contracts-form__grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 28px;
}

.contracts-form__col {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.contracts-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.contracts-field__label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}

.contracts-input,
.contracts-textarea {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
}
.contracts-input:focus,
.contracts-textarea:focus {
  outline: none;
  border-color: var(--gold-main);
}
.contracts-input::placeholder,
.contracts-textarea::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}

.contracts-textarea {
  min-height: 112px;
  resize: vertical;
  line-height: 1.45;
}

.contracts-counter {
  align-self: flex-end;
  font-size: 12px;
  color: #8d8a82;
}

.contracts-error {
  font-size: 13px;
  color: #d9786d;
}

.contracts-summary {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.contracts-summary__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  color: #aeaba2;
}
.contracts-summary__row strong {
  font-size: 18px;
  font-weight: 600;
  color: var(--gold-light);
}
.contracts-summary .contracts-button {
  align-self: stretch;
  padding: 12px 18px;
  font-size: 15px;
}

.contracts-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.contracts-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.contracts-button:active:not(:disabled) {
  transform: translateY(1px);
}
.contracts-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.contracts-button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.contracts-button--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.contracts-button--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.contracts-button--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.contracts-button--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.contracts-button--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.contracts-button--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}

.contracts-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #8d8a82;
  text-align: center;
}

.contracts-close-row {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.contracts-keyhint {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8d8a82;
}
.contracts-keyhint kbd {
  padding: 1px 7px;
  font-family: inherit;
  font-size: 12px;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

@media (max-width: 760px) {
  .contracts-split {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }
  .contracts-pane {
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  .contracts-form__grid {
    grid-template-columns: 1fr;
  }
  .contracts-header__sub {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/contracts/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDgBU;ACVZ;;AAHA;EDgBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;EC1JA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAYF;ADFE;EAAI,sBAAA;ACKN;ADwIE;EC/JF;ID+J4C,eAAA;ECpI1C;AACF;AAlBE;EAA4B,SAAA;EAAW,UAAA;AAsBzC;AArBE;EAAK,gBAAA;AAwBP;;AAjBA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AAoBF;AAlBE;EDaA,kDA3BW;EA4BX,gBAAA;EACA,eCf8B;EDgB9B,iBAAA;EACA,sBAAA;EACA,cAxCK;ACgDP;AAzBE;ED2BA,eAAA;EACA,gBAAA;EACA,cAlDO;ECqBqB,eAAA;AA+B9B;AA7BE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBD3BK;AC0DT;AA7BI;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cDhCrC;ACkET;AAjCI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;AAmCN;;AA9BA;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,kDAAA;AAiCF;;AA9BA;EDiHE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AC/EF;ADiFE;EAAU,cAnLL;ACqGP;AD+EE;EAAkB,oCAAA;EAAsC,oBAAA;AC3E1D;AAlDE;EDiIA,wBAAA;EACA,qCAAA;AC5EF;AApDE;ED2EA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAzIO;EA0IP,qCAAA;EACA,mBAAA;ACpBF;;AA5DA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDlEK;ECmEL,qCDvEW;ECwEX,2CAAA;EACA,sBAAA;EACA,kBDjEO;ACgIT;AA7DE;EAAQ,0BDpEA;ACoIV;AA/DE;EAAW,0BDtEJ;ACwIT;;AA/DA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAkEF;;AA3DA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,0DAAA;AA8DF;;AA3DA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iDAAA;AA8DF;;AA3DA;EACE,cAAA;EACA,sBAAA;AA8DF;;AA3DA;EACE,aAAA;EACA,QAAA;EAGA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qDAAA;AA4DF;AA1DE;EAAuB,WAAA;AA6DzB;AA5DE;EAA6B,oCAAA;EAAsC,kBAAA;AAgErE;AA9DE;EAAU,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;AAmEhD;;AAhEA;EACE,cAAA;EACA,iBAAA;EACA,yDDpHU;ECqHV,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cDhIO;ECiIP,uBAAA;EACA,0CAAA;EACA,kBD/HO;ECgIP,eAAA;EACA,kFAAA;AAmEF;AAjEE;EAAU,cDxIL;ECwIuB,8BAAA;AAqE9B;AApEE;EAAkB,oCAAA;EAAsC,mBAAA;AAwE1D;AAtEE;EACE,cDtIQ;ECuIR,4BAAA;EACA,8BAAA;AAwEJ;AAvEI;EAAU,cDzIF;ECyIyB,8BAAA;AA2ErC;AAxEE;EAAY,eAAA;AA2Ed;AA3E+B;EAAU,cDjJhC;ECiJoD,sCDnJ/C;ACkOd;;AA5EA;EDnGE,eAAA;EACA,gBAAA;EACA,cAlDO;ACqOT;;AA9EA;EDTE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECSA,OAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;AAmFF;AD7FE;EAAuB,UAAA;ACgGzB;AD/FE;EAA6B,oCAAA;EAAsC,kBAAA;ACmGrE;;AAnFA;EACE,kBAAA;EACA,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cD/KO;ECgLP,uBAAA;EACA,SAAA;EACA,kBD9KO;EC+KP,eAAA;EACA,sCAAA;AAsFF;AApFE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,6BAAA;AAsFJ;AAnFE;EAAU,qCAAA;AAsFZ;AArFE;EAAkB,oCAAA;EAAsC,oBAAA;AAyF1D;AAvFE;EACE,qCAAA;AAyFJ;AAxFI;EAAY,UAAA;AA2FhB;;AAvFA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA0FF;AAxFE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;AA0FJ;AAxFE;EAAO,eAAA;EAAiB,eAAA;EAAiB,cDvNlC;ACoTT;;AA1FA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA6FF;;AA1FA;EACE,eAAA;EACA,gBAAA;EACA,cDtOK;ECuOL,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6FF;;AA1FA;EACE,eAAA;EACA,cD5OO;EC6OP,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6FF;;AA1FA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AA6FF;;AA1FA;EACE,eAAA;EACA,cD3PO;EC4PP,mBAAA;AA6FF;;AAzFA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cDvQO;ECwQP,0CAAA;EACA,kBDrQO;ACiWT;AA1FE;EAAU,wBAAA;EAA0B,8BAAA;AA8FtC;AA7FE;EAAc,cD7QT;AC6WP;AA/FE;EAAe,cD1QP;EC0Q4B,sCAAA;AAmGtC;AAlGE;EAAa,cD3QL;EC2Q0B,sCAAA;AAsGpC;AArGE;EACa,cD/QN;ACsXT;AAtGE;EAAc,cD/QP;EC+Q2B,sCAAA;AA0GpC;;AAnGA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,qCAAA;AAsGF;AApGE;EACE,mBAAA;EACA,uBAAA;EACA,cDhSK;ECiSL,eAAA;EACA,kBAAA;EACA,aAAA;AAsGJ;AAnGE;EACE,cAAA;EACA,uBAAA;EACA,kDAAA;AAqGJ;AAlGE;EAAU,aAAA;EAAe,QAAA;EAAU,mBAAA;AAuGrC;AArGE;ED7QA,kDA3BW;EA4BX,gBAAA;EACA,eC2Q8B;ED1Q9B,iBAAA;EACA,sBAAA;EACA,cAxCK;ECgTgC,uBAAA;AA8GvC;AA5GE;EACE,gBAAA;EACA,eAAA;EACA,cDpTK;ACkaT;AA5GI;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;AA8GN;AA1GE;ED/KA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC+KE,OAAA;EACA,aAAA;EACA,kBAAA;AA8GJ;AD7RE;EAAuB,UAAA;ACgSzB;AD/RE;EAA6B,oCAAA;EAAsC,kBAAA;ACmSrE;AAlHE;EACE,eAAA;EACA,iBAAA;EACA,cDzUG;EC0UH,uBAAA;EACA,qBAAA;AAoHJ;AAlHI;EAAU,cD3UL;ACgcT;AAlHE;EACE,kBAAA;EACA,kDD1US;EC2UT,gBAAA;EACA,eAAA;AAoHJ;AAjHE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;EACA,uBAAA;EACA,+CAAA;AAmHJ;;AA/GA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAkHF;AAhHE;EACE,kBAAA;EACA,qCD7WS;EC8WT,2CAAA;EACA,kBDtWK;ACwdT;AA/GE;EAAK,eAAA;EAAiB,gBAAA;EAAkB,cD5WjC;ACgeT;AAnHE;EAAK,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,cD/WpD;EC+WsE,uBAAA;AA0H7E;;AAvHA;EACE,aAAA;EACA,sBAAA;AA0HF;AAxHE;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cD3XK;EC4XL,+CAAA;AA0HJ;AAvHE;EAAU,eAAA;EAAiB,cD9XpB;EC8XwC,mBAAA;AA4HjD;;AArHA;EDvPE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECuPA,OAAA;EACA,aAAA;EACA,kBAAA;AA0HF;ADjXE;EAAuB,UAAA;ACoXzB;ADnXE;EAA6B,oCAAA;EAAsC,kBAAA;ACuXrE;;AA9HA;EACE,aAAA;EACA,uDAAA;EACA,SAAA;AAiIF;;AA9HA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAiIF;;AA9HA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAiIF;AA/HE;EDvWA,eAAA;EACA,gBAAA;EACA,cAzDO;ACkiBT;;AAjIA;;ED9SE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ACobF;ADlbE;;EAAU,aAAA;EAAe,8BAAA;ACub3B;ADtbE;;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC8b1G;;AAxJA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;AA2JF;;AAxJA;EACE,oBAAA;EACA,eAAA;EACA,cD5aO;ACukBT;;AAxJA;EACE,eAAA;EACA,cDhbO;AC2kBT;;AAxJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,qCD/bW;ECgcX,2CAAA;EACA,kBDxbO;ACmlBT;AAzJE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,cDpcK;AC+lBT;AAzJI;EAAS,eAAA;EAAiB,gBAAA;EAAkB,wBAAA;AA8JhD;AA3JE;EAAoB,mBAAA;EAAqB,kBAAA;EAAoB,eAAA;AAgK/D;;AAzJA;EDlZE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;AC+iBF;AD7iBE;EAAyB,qCAAA;EAAuC,8BAAA;ACijBlE;ADhjBE;EAA0B,0BAAA;ACmjB5B;ADljBE;EAAa,YAAA;EAAc,mBAAA;ACsjB7B;ADrjBE;EAAkB,oCAAA;EAAsC,mBAAA;ACyjB1D;AAxLE;ED7XA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACwjBF;ADtjBE;EAAyB,6BAAA;EAA+B,+BAAA;AC0jB1D;AAhME;EDtXA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACyjBF;ADvjBE;EAAyB,qCAAA;EAAuC,qBAhGzD;AC2pBT;AAxME;ED/WA,cArGO;EAsGP,uBAAA;EACA,yBAAA;AC0jBF;ADxjBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC6jBhF;;AA/MA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDjeO;ECkeP,kBAAA;AAkNF;;AA/MA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,+CAAA;AAkNF;;AA/MA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDnfO;ACqsBT;AAhNE;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,cD1fK;EC2fL,qCAAA;EACA,0CAAA;EACA,kBAAA;AAkNJ;;AA9MA;EACE;IAAmB,0BAAA;IAA4B,iDAAA;EAmN/C;EAlNA;IAAkB,eAAA;IAAiB,kDAAA;EAsNnC;EArNA;IAAwB,0BAAA;EAwNxB;EAvNA;IAAyB,aAAA;EA0NzB;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Player contracts: a registry with the list on the left and the selected\n// contract on the right (same workbench layout as the craft menu), in the\n// shared ink look (see theme/_ink.scss). One accent, one radius.\n@use '../../theme/ink' as ink;\n\n.contracts-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(2, 3, 8, 0.6);\n  pointer-events: none;\n  font-family: ink.$font-text;\n}\n\n.contracts-panel {\n  @include ink.panel;\n  @include ink.enter;\n  pointer-events: auto;\n  width: min(1000px, 94vw);\n  height: min(680px, 90vh);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  h1, h2, h3, p, ul, dl, dd { margin: 0; padding: 0; }\n  ul { list-style: none; }\n}\n\n// ---------------------------------------------------------------------------\n// Header and tabs\n// ---------------------------------------------------------------------------\n\n.contracts-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 24px 12px;\n\n  &__title { @include ink.title(28px); }\n  &__sub { @include ink.hint; margin-top: 4px; }\n\n  &__purse {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 1px;\n    padding: 6px 14px;\n    border: 1px solid var(--gold-dark);\n    border-radius: ink.$radius;\n\n    span { font-size: 12px; font-weight: 600; color: ink.$text-3; }\n    strong {\n      font-size: 17px;\n      font-weight: 600;\n      color: var(--gold-light);\n      font-variant-numeric: tabular-nums;\n    }\n  }\n}\n\n.contracts-tabs {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 2px;\n  padding: 0 24px;\n  border-bottom: 1px solid ink.$line;\n}\n\n.contracts-tab {\n  @include ink.tab;\n\n  &--active { @include ink.tab-active; }\n\n  &__count { @include ink.badge; }\n}\n\n.contracts-notice {\n  flex: 0 0 auto;\n  margin: 12px 24px 0;\n  padding: 9px 12px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: ink.$text;\n  background: ink.$ink-raised;\n  border: 1px solid ink.$line;\n  border-left-width: 3px;\n  border-radius: ink.$radius;\n\n  &--ok { border-left-color: ink.$success; }\n  &--error { border-left-color: ink.$danger; }\n}\n\n.contracts-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n// ---------------------------------------------------------------------------\n// Split: list and detail\n// ---------------------------------------------------------------------------\n\n.contracts-split {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);\n}\n\n.contracts-pane {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border-right: 1px solid ink.$line;\n}\n\n.contracts-filter {\n  flex: 0 0 auto;\n  padding: 14px 16px 6px;\n}\n\n.contracts-chips {\n  display: flex;\n  gap: 6px;\n  // Single scrollable line in the list header, so eleven categories never\n  // eat the height of the list; the form lets them wrap instead.\n  overflow-x: auto;\n  padding-bottom: 8px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { height: 4px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 2px; }\n\n  &--wrap { flex-wrap: wrap; overflow: visible; padding-bottom: 0; }\n}\n\n.contracts-chip {\n  flex: 0 0 auto;\n  padding: 5px 11px;\n  font-family: ink.$font-text;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: ink.$text-2;\n  background: transparent;\n  border: 1px solid ink.$line-strong;\n  border-radius: ink.$radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n\n  &:hover { color: ink.$text; border-color: var(--gold-dark); }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n  &--active {\n    color: ink.$on-accent;\n    background: var(--gold-main);\n    border-color: var(--gold-main);\n    &:hover { color: ink.$on-accent; border-color: var(--gold-main); }\n  }\n\n  &--static { cursor: default; &:hover { color: ink.$text-2; border-color: ink.$line-strong; } }\n}\n\n.contracts-hint {\n  @include ink.hint;\n}\n\n.contracts-list {\n  @include ink.scroll;\n  flex: 1;\n  min-height: 0;\n  padding: 4px 10px 12px 12px;\n  scrollbar-gutter: stable;\n}\n\n// ---------------------------------------------------------------------------\n// Row\n// ---------------------------------------------------------------------------\n\n.contracts-row {\n  position: relative;\n  display: grid;\n  grid-template-columns: 74px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 10px 10px 12px;\n  margin-bottom: 2px;\n  font-family: inherit;\n  text-align: left;\n  color: ink.$text-2;\n  background: transparent;\n  border: 0;\n  border-radius: ink.$radius;\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 20%;\n    bottom: 20%;\n    width: 3px;\n    border-radius: 2px;\n    background: var(--gold-main);\n    opacity: 0;\n    transition: opacity 0.1s ease;\n  }\n\n  &:hover { background: rgba(255, 255, 255, 0.06); }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n  &--selected {\n    background: rgba(255, 255, 255, 0.09);\n    &::before { opacity: 1; }\n  }\n}\n\n.contracts-row__reward {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.1;\n\n  strong {\n    font-size: 21px;\n    font-weight: 600;\n    color: var(--gold-light);\n    font-variant-numeric: tabular-nums;\n  }\n  span { margin-top: 2px; font-size: 12px; color: ink.$text-3; }\n}\n\n.contracts-row__main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.contracts-row__title {\n  font-size: 15px;\n  font-weight: 600;\n  color: ink.$text;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.contracts-row__sub {\n  font-size: 13px;\n  color: ink.$text-3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.contracts-row__side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.contracts-row__time {\n  font-size: 12px;\n  color: ink.$text-3;\n  white-space: nowrap;\n}\n\n// State tags: semantic colour only on the text and border, never a fill.\n.contracts-tag {\n  display: inline-block;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  color: ink.$text-2;\n  border: 1px solid ink.$line-strong;\n  border-radius: ink.$radius;\n\n  &--open { color: var(--gold-light); border-color: var(--gold-dark); }\n  &--accepted { color: ink.$text; }\n  &--delivered { color: ink.$success; border-color: rgba(143, 191, 138, 0.5); }\n  &--settled { color: ink.$success; border-color: rgba(143, 191, 138, 0.5); }\n  &--cancelled,\n  &--expired { color: ink.$text-3; }\n  &--disputed { color: ink.$danger; border-color: rgba(217, 120, 109, 0.5); }\n}\n\n// ---------------------------------------------------------------------------\n// Detail\n// ---------------------------------------------------------------------------\n\n.contracts-detail {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: rgba(255, 255, 255, 0.02);\n\n  &--empty {\n    align-items: center;\n    justify-content: center;\n    color: ink.$text-3;\n    font-size: 14px;\n    text-align: center;\n    padding: 24px;\n  }\n\n  &__top {\n    flex: 0 0 auto;\n    padding: 22px 26px 16px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__tags { display: flex; gap: 6px; margin-bottom: 12px; }\n\n  &__title { @include ink.title(26px); overflow-wrap: anywhere; }\n\n  &__reward {\n    margin-top: 10px;\n    font-size: 15px;\n    color: ink.$text-2;\n\n    strong {\n      font-size: 30px;\n      font-weight: 600;\n      color: var(--gold-light);\n      font-variant-numeric: tabular-nums;\n    }\n  }\n\n  &__body {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    padding: 18px 26px;\n  }\n\n  &__text {\n    font-size: 15px;\n    line-height: 1.55;\n    color: ink.$text;\n    overflow-wrap: anywhere;\n    white-space: pre-wrap;\n\n    &--none { color: ink.$text-3; }\n  }\n\n  &__heading {\n    margin: 22px 0 8px;\n    font-family: ink.$font-title;\n    font-weight: 400;\n    font-size: 17px;\n  }\n\n  &__actions {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 14px 26px 18px;\n    border-top: 1px solid ink.$line;\n  }\n}\n\n.contracts-facts {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 10px;\n  margin-top: 18px;\n\n  > div {\n    padding: 10px 12px;\n    background: ink.$ink-raised;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n  }\n\n  dt { font-size: 12px; font-weight: 600; color: ink.$text-3; }\n  dd { margin-top: 3px; font-size: 14px; font-weight: 600; color: ink.$text; overflow-wrap: anywhere; }\n}\n\n.contracts-log {\n  display: flex;\n  flex-direction: column;\n\n  li {\n    display: grid;\n    grid-template-columns: 86px minmax(0, 1fr);\n    gap: 12px;\n    padding: 7px 0;\n    font-size: 14px;\n    color: ink.$text-2;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__date { font-size: 13px; color: ink.$text-3; white-space: nowrap; }\n}\n\n// ---------------------------------------------------------------------------\n// Form\n// ---------------------------------------------------------------------------\n\n.contracts-form {\n  @include ink.scroll;\n  flex: 1;\n  min-height: 0;\n  padding: 20px 24px;\n}\n\n.contracts-form__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);\n  gap: 28px;\n}\n\n.contracts-form__col {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.contracts-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  &__label { @include ink.label; }\n}\n\n.contracts-input,\n.contracts-textarea { @include ink.field; }\n\n.contracts-textarea {\n  min-height: 112px;\n  resize: vertical;\n  line-height: 1.45;\n}\n\n.contracts-counter {\n  align-self: flex-end;\n  font-size: 12px;\n  color: ink.$text-3;\n}\n\n.contracts-error {\n  font-size: 13px;\n  color: ink.$danger;\n}\n\n.contracts-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  background: ink.$ink-raised;\n  border: 1px solid ink.$line;\n  border-radius: ink.$radius;\n\n  &__row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 14px;\n    color: ink.$text-2;\n\n    strong { font-size: 18px; font-weight: 600; color: var(--gold-light); }\n  }\n\n  .contracts-button { align-self: stretch; padding: 12px 18px; font-size: 15px; }\n}\n\n// ---------------------------------------------------------------------------\n// Buttons, empty state, footer\n// ---------------------------------------------------------------------------\n\n.contracts-button {\n  @include ink.button;\n\n  &--primary { @include ink.button-primary; }\n  &--danger { @include ink.button-danger; }\n  &--quiet { @include ink.button-quiet; }\n}\n\n.contracts-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 32px 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: ink.$text-3;\n  text-align: center;\n}\n\n.contracts-close-row {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  border-top: 1px solid ink.$line;\n}\n\n.contracts-keyhint {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: ink.$text-3;\n\n  kbd {\n    padding: 1px 7px;\n    font-family: inherit;\n    font-size: 12px;\n    color: ink.$text-2;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid ink.$line-strong;\n    border-radius: 4px;\n  }\n}\n\n@media (max-width: 760px) {\n  .contracts-split { grid-template-columns: 1fr; grid-template-rows: minmax(0, 1fr) minmax(0, 1fr); }\n  .contracts-pane { border-right: 0; border-bottom: 1px solid ink.$line; }\n  .contracts-form__grid { grid-template-columns: 1fr; }\n  .contracts-header__sub { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
